
import { LogEntry } from '../types';

/**
 * Phase 12: Simulated Logging Service
 * Provides structured JSON-like logging for production observability.
 */

const MAX_LOGS = 100;
let logs: LogEntry[] = JSON.parse(localStorage.getItem('agri_logs') || '[]');

const saveLogs = () => {
  if (logs.length > MAX_LOGS) {
    logs = logs.slice(-MAX_LOGS);
  }
  localStorage.setItem('agri_logs', JSON.stringify(logs));
  window.dispatchEvent(new CustomEvent('agri_new_log'));
};

const createEntry = (level: LogEntry['level'], message: string, context?: any): LogEntry => ({
  id: crypto.randomUUID(),
  timestamp: Date.now(),
  level,
  message,
  context
});

export const logger = {
  info: (message: string, context?: any) => {
    console.info(`[INFO] ${message}`, context || '');
    logs.push(createEntry('info', message, context));
    saveLogs();
  },
  warn: (message: string, context?: any) => {
    console.warn(`[WARN] ${message}`, context || '');
    logs.push(createEntry('warn', message, context));
    saveLogs();
  },
  error: (message: string, context?: any) => {
    console.error(`[ERROR] ${message}`, context || '');
    logs.push(createEntry('error', message, context));
    saveLogs();
  },
  debug: (message: string, context?: any) => {
    if (process.env.NODE_ENV !== 'production') {
      console.debug(`[DEBUG] ${message}`, context || '');
    }
    logs.push(createEntry('debug', message, context));
    saveLogs();
  },
  getLogs: (): LogEntry[] => [...logs].reverse(),
  clearLogs: () => {
    logs = [];
    saveLogs();
  }
};
